import Card from '@/components/card/card-component';
import { Col } from '@/components/grid/grid-component';
import { SubheaderText } from '@/utils/global-fonts';
import PropTypes from 'prop-types';
import { FiPercent } from 'react-icons/fi';
import { MdOutlineAddCircleOutline, MdOutlineUnfoldMore } from 'react-icons/md';
import theme from '@/common/theme';
import Styled from './quote-module-price-style';

const cardBodyStyle = {
  padding: '0px',
  display: 'flex',
  flexDirection: 'column',
};

const colStyle = {
  marginTop: '24px',
  height: 'unset',
};

/**
 * Quoting Module Price component
 * @param {object} props - props
 * @param {func} props.setOpenEditModal - function to open modal
 * @param {func} props.setOpenCreateModal - function to open modal
 * @param {func} props.setModuleIdToEdit - function to set Module to edit
 * @param {func} props.setModuleIdToDelete - function to set Module to delete
 * @param {func} props.deleteQuoteModuleHandler - function to delete Module
 * @param {Array} props.data - function to open modal
 * @returns {JSX.Element} component
 */
const QuoteModulePrice = ({
  setOpenCreateModal,
  setOpenEditModal,
  setModuleIdToEdit,
  setModuleIdToDelete,
  deleteQuoteModuleHandler,
  data,
}) => (
  <Styled.CardStyle bodyStyle={cardBodyStyle}>
    <Styled.RowStyle>
      <Col xs={12} md={4} style={colStyle}>
        <Card padding="24px" bodyStyle={cardBodyStyle}>
          <SubheaderText>Discount</SubheaderText>
          <Styled.Line />
          <Styled.LabelText>Discount</Styled.LabelText>
          <Styled.Container>
            <FiPercent color={theme.COLOR_GREY3} size={20} />
          </Styled.Container>
          <Styled.LabelText>Discount Comment</Styled.LabelText>
          <Styled.Container />
          <Styled.LabelText>Quantity</Styled.LabelText>
          <Styled.Container>
            <MdOutlineUnfoldMore color={theme.COLOR_TEXT} size={20} />
          </Styled.Container>
        </Card>
      </Col>
      {data.map((module) => (
        <Col xs={12} md={4} key={module.id} style={colStyle}>
          <Styled.ModuleCard padding="24px" bodyStyle={cardBodyStyle}>
            <Styled.HeadingDiv>
              <Styled.Title>{module.title}</Styled.Title>
              <Styled.IconDiv>
                <Styled.EditIcon
                  color={theme.COLOR_GREY3}
                  size={16}
                  onClick={() => {
                    setModuleIdToEdit(module.id);
                    setOpenEditModal(true);
                  }}
                />
                <Styled.DeleteIcon
                  onClick={() => {
                    setModuleIdToDelete(module.id);
                    deleteQuoteModuleHandler();
                  }}
                  color={theme.COLOR_GREY3}
                  size={24}
                />
              </Styled.IconDiv>
            </Styled.HeadingDiv>
            <Styled.Description>{module.description}</Styled.Description>
            <Styled.Line />
            <Styled.LabelText>Price</Styled.LabelText>
            <Styled.Container />
            <Styled.LabelText>Message</Styled.LabelText>
            <Styled.Container />
          </Styled.ModuleCard>
        </Col>
      ))}
      <Col xs={12} md={4} style={colStyle}>
        <Styled.AddModuleCard bodyStyle={cardBodyStyle}>
          <Styled.AddModuleRow
            onClick={() => {
              setOpenCreateModal(true);
            }}
          >
            <MdOutlineAddCircleOutline color={theme.COLOR_GREY3} size={40} />
            <Styled.AddModuleText color={theme.COLOR_GREY3}>
              Add New Price Module
            </Styled.AddModuleText>
          </Styled.AddModuleRow>
        </Styled.AddModuleCard>
      </Col>
    </Styled.RowStyle>
  </Styled.CardStyle>
);

QuoteModulePrice.propTypes = {
  setOpenCreateModal: PropTypes.func.isRequired,
  setOpenEditModal: PropTypes.func.isRequired,
  setModuleIdToEdit: PropTypes.func.isRequired,
  setModuleIdToDelete: PropTypes.func.isRequired,
  deleteQuoteModuleHandler: PropTypes.func.isRequired,
  data: PropTypes.shape([]),
};

QuoteModulePrice.defaultProps = {
  data: [],
};

export default QuoteModulePrice;
